module.exports = __webpack_public_path__ + "img/vertical_3_1_1.cb8a0926.png";